import type { ReactNode } from 'react'

import { useTheme } from '../../theme/ThemeContext'
import { loginHeroPanelClass } from './loginSurfaceStyles'

type Props = {
  children: ReactNode
  className?: string
}

/**
 * 登录页左侧介绍区玻璃面板：样式由 {@link loginHeroPanelClass} 统一生成，与右侧 {@link LoginAuthCard} 同源 token。
 */
export function LoginHeroPanel({ children, className }: Props) {
  const { theme } = useTheme()
  return (
    <div className={[loginHeroPanelClass(theme), className].filter(Boolean).join(' ')}>
      {children}
    </div>
  )
}
